import { Flex, Alert } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { useEffect, useMemo } from "react";
import { useRouteError, isRouteErrorResponse, useNavigate } from "react-router-dom";
import useSignOutHandler from "@/hooks/useSignOutHandler";
import useUserStore from "@/modules/users/store";
import { captureException } from "@/services/log";

const HTTP_NOT_FOUND = 404;

/**
 * Error Login Page
 * @returns - Error Login Page
 */
function ErrorPage() {
  const error = useRouteError() as Error;
  const navigate = useNavigate();
  const resetState = useUserStore((state) => state.reset);
  const signOutHandler = useSignOutHandler();
  const messageError = useMemo(() => {
    if (isRouteErrorResponse(error) && typeof error.data === "string") {
      return error.data;
    }
    if (error instanceof Error) {
      return error.message;
    }
    return "";
  }, [error]);

  const isNotFoundResponse = useMemo(() => isRouteErrorResponse(error) && error.status === HTTP_NOT_FOUND, [error]);

  const shouldAutoLogout = useMemo(
    () => messageError.includes("responderQuestionario") || messageError.includes("auto-cadastro"),
    [messageError]
  );

  const destino = useMemo(() => extractUrl(messageError) ?? "/", [messageError]);

  let errorMessage = "A PAGINA PROCURADA NÃO EXISTE!";
  if (isRouteErrorResponse(error)) {
    errorMessage = error?.message ?? errorMessage;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  useEffect(() => {
    captureException(error);
  }, [error]);

  if (shouldAutoLogout) {
    signOutHandler().catch((error_) => {
      console.error("Erro durante o logout:", error_);
    });
    resetState();
    navigate(destino, { replace: true });
    //window.location.reload();
  }

  return (
    <Flex mih="90vh" gap="xs" justify="center" align="center" direction="column" wrap="nowrap">
      <Alert
        icon={<IconAlertCircle size={16} />}
        title={isNotFoundResponse ? "NÃO ENCONTRADO!" : "Ops"}
        color={isNotFoundResponse ? "yellow" : "red"}
        variant="outline"
      >
        {errorMessage}
      </Alert>
    </Flex>
  );
}

export default ErrorPage;

/**
 *
 * @param errorMessage - msg de erro
 * @returns - url
 */
function extractUrl(errorMessage: string): string | null {
  const match = errorMessage.match(/URL\s*"([^"]+)"/);
  return match?.[1] ?? null;
}
